import { render, staticRenderFns } from "./Waybills.vue?vue&type=template&id=136a23be&"
import script from "./Waybills.vue?vue&type=script&lang=js&"
export * from "./Waybills.vue?vue&type=script&lang=js&"
import style0 from "./Waybills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../home/makeeva/projects/mbelab/html/lk.mbelab.com/vue-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../home/makeeva/projects/mbelab/html/lk.mbelab.com/vue-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDataTable,VDatePicker,VDialog,VIcon,VMenu,VRow,VSpacer,VTextField})
